import { Store, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Action, ActionType } from './actions';
import { combinedAppReducers } from './reducers';
import { AuthStateData } from './state/AuthStateData';
import { FormData } from './state/SearchManager/FormData';
import { ResultsData } from './state/SearchManager/ResultsData';
import { RuleData } from './state/SearchManager/RuleData';
import { RuleSearchesFormData } from './state/SearchManager/RuleSearchesFormData';
import { RuleSearchesResultsData } from './state/SearchManager/RuleSearchesResultsData';
import { RuleItemEditFormData } from './state/SearchManager/RuleItemEditFormData';
import { FormData as ShoppingDiagnosticsFormDataLive } from './state/ShoppingDiagnostics/FormData';
import { ResultsData as ShoppingDiagnosticsResultsDataLive } from './state/ShoppingDiagnostics/ResultsData';
import { FormData as ShoppingDiagnosticsFormDataHistorical } from './state/ShoppingDiagnostics/FormDataHistorical';
import { ResultsData as ShoppingDiagnosticsResultsDataHistorical } from './state/ShoppingDiagnostics/ResultsDataHistorical';
import { BookingFormData } from './state/BookingDiagnostics/FormData';
import { BookingResultsData } from './state/BookingDiagnostics/ResultsData';
import { FormData as BookingCreateManagerFormData } from './state/BookingCreateManager/FormData';
import { ResultsData as BookingCreateManagerResultsData } from './state/BookingCreateManager/ResultsData';
import { RuleData as BookingCreateManagerRuleData } from './state/BookingCreateManager/RuleData';
import { RemarksFormData as BookingCreateManagerRemarksFormData } from './state/BookingCreateManager/RemarksFormData';
import { RemarksResultsData as BookingCreateManagerRemarksResultsData } from './state/BookingCreateManager/RemarksResultsData';
import { RemarksRuleData as BookingCreateManagerRemarksRuleData } from './state/BookingCreateManager/RemarksRuleData';
import { FormData as RegionsFormData } from './state/Regions/FormData';
import { ResultsData as RegionsResultsData } from './state/Regions/ResultsData';
import { RegionEditorData } from './state/Regions/EditorData';
import { FormData as CountriesFormData } from './state/Countries/FormData';
import { ResultsData as CountriesResultsData } from './state/Countries/ResultsData';
import { CountryEditorData } from './state/Countries/EditorData';
import { FormData as LocationsFormData } from './state/Locations/FormData';
import { ResultsData as LocationsResultsData } from './state/Locations/ResultsData';
import { LocationEditorData } from './state/Locations/EditorData';
import { FormData as StationsFormData } from './state/Stations/FormData';
import { ResultsData as StationsResultsData } from './state/Stations/ResultsData';
import { StationEditorData } from './state/Stations/EditorData';
import { FormData as AirlinesFormData } from './state/Airlines/FormData';
import { ResultsData as AirlinesResultsData } from './state/Airlines/ResultsData';
import { AirlineEditorData } from './state/Airlines/EditorData';
import { BrandEditorData } from './state/Brands/EditorData';
import { FormData as BrandsFormData } from './state/Brands/FormData';
import { ResultsData as BrandsResultsData } from './state/Brands/ResultsData';
import { MarketEditorData } from './state/Markets/EditorData';
import { FormData as MarketsFormData } from './state/Markets/FormData';
import { ResultsData as MarketsResultsData } from './state/Markets/ResultsData';
import { DistributionChannelEditorData } from './state/DistributionChannels/EditorData';
import { FormData as DistributionChannelsFormData } from './state/DistributionChannels/FormData';
import { ResultsData as DistributionChannelsResultsData } from './state/DistributionChannels/ResultsData';
import { AgencyEditorData } from './state/Agencies/EditorData';
import { FormData as AgenciesFormData } from './state/Agencies/FormData';
import { ResultsData as AgenciesResultsData } from './state/Agencies/ResultsData';
import { AgencyGroupEditorData } from './state/AgencyGroups/EditorData';
import { FormData as AgencyGroupsFormData } from './state/AgencyGroups/FormData';
import { ResultsData as AgencyGroupsResultsData } from './state/AgencyGroups/ResultsData';
import { FormData as MarkupsFormData } from './state/Markups/FormData';
import { ResultsData as MarkupsResultsData } from './state/Markups/ResultsData';
import { MarkupEditorData } from './state/Markups/MarkupEditorData';
import { ProviderPreferenceEditorData } from './state/ProviderPreferences/EditorData';
import { FormData as ProviderPreferencesFormData } from './state/ProviderPreferences/FormData';
import { ResultsData as ProviderPreferencesResultsData } from './state/ProviderPreferences/ResultsData';
import { ProviderCredentialsEditorData } from './state/ProviderCredentials/EditorData';
import { FormData as ProviderCredentialFormData } from './state/ProviderCredentials/FormData';
import { ResultsData as ProviderCredentialsResultsData } from './state/ProviderCredentials/ResultsData';
import { FormData as IdentityProviderSettingsFormData } from './state/IdentityProviderSettings/FormData';
import { ResultsData as IdentityProviderSettingsResultsData } from './state/IdentityProviderSettings/ResultsData';
import { EditorData as IdentityProviderSettingsEditorData } from './state/IdentityProviderSettings/EditorData';
import { FormData as IdentitySettingsFormData } from './state/IdentitySettings/FormData';
import { ResultsData as IdentitySettingsResultsData } from './state/IdentitySettings/ResultsData';
import { EditorData as IdentitySettingsEditorData } from './state/IdentitySettings/EditorData';
import { TicketTLOEditorData } from './state/TicketTLO/EditorData';
import { FormData as TicketTLOFormData } from './state/TicketTLO/FormData';
import { ResultsData as TicketTLOResultsData } from './state/TicketTLO/ResultsData';
import { FormData as UserPermissionsFormData } from './state/UserPermissions/FormData';
import { ResultsData as UserPermissionsResultsData } from './state/UserPermissions/ResultsData';
import { UserPermissionsEditorData } from './state/UserPermissions/EditorData';
import { FormData as GlobalFiltersFormData } from './state/GlobalFilters/FormData';
import { ResultsData as GlobalFiltersResultsData } from './state/GlobalFilters/ResultsData';
import { EditorData as GlobalFiltersEditorData } from './state/GlobalFilters/EditorData';
import { FormData as ActivityLogFormData } from './state/ActivityLog/FormData';
import { ResultsData as ActivityLogResultsData } from './state/ActivityLog/ResultsData';
import { EditorData as GeoGroupsEditorData } from './state/GeoGroups/EditorData';
import { FiltersData as GeoGroupsFiltersData } from './state/GeoGroups/FiltersData';
import { TableData as GeoGroupsTableData } from './state/GeoGroups/TableData';
import { EditorData as SupplierEditorData } from './state/Supplier/EditorData';
import { TableData as SupplierTableData } from './state/Supplier/TableData';
import { FiltersData as AncillariesMappingFiltersData } from './state/AncillariesMapping/FiltersData';
import { TableData as AncillariesMappingTableData } from './state/AncillariesMapping/TableData';
import { EditorData as AncillariesMappingEditorData } from './state/AncillariesMapping/EditorData';
import { FiltersData as AncillaryDistributionFiltersData } from './state/AncillaryDistribution/FiltersData';
import { EditorData as AncillaryDistributionEditorData } from './state/AncillaryDistribution/EditorData';
import { TableData as AncillaryDistributionTableData } from './state/AncillaryDistribution/TableData';
import { FiltersData as SearchManagerV2FormData } from './state/SearchManagerV2/FiltersData';
import { FiltersData as MarkupsV2FilterData } from './state/MarkupsV2/FiltersData';
import { TableData as SearchManagerV2TableData } from './state/SearchManagerV2/TableData';
import { EditorData as SearchManagerV2EditorData } from './state/SearchManagerV2/EditorData';

import { FiltersData as TicketTLOV2FormData } from './state/TicketTLOV2/FiltersData';
import { TableData as TicketTLOVV2TableData } from './state/TicketTLOV2/TableData';
import { EditorData as TicketTLOVV2EditorData } from './state/TicketTLOV2/EditorData';
import { FiltersData as GlobalFiltersV2FiltersData } from './state/GlobalFiltersV2/FiltersData';
import { TableData as GlobalFiltersV2TableData } from './state/GlobalFiltersV2/TableData';
import { EditorData as GlobalFiltersV2EditorData } from './state/GlobalFiltersV2/EditorData';

import { FiltersData as ProviderCredentialsV2FiltersData } from './state/ProviderCredentialsV2/FiltersData';
import { TableData as ProviderCredentialsV2TableData } from './state/ProviderCredentialsV2/TableData';
import { EditorData as ProviderCredentialsV2EditorData } from './state/ProviderCredentialsV2/EditorData';

import { RuleSearchesData as SearchManagerV2RuleSearchesData } from './state/SearchManagerV2/RuleSearchesData';
import { RuleSearchesTableData as SearchManagerV2RuleSearchesTableData } from './state/SearchManagerV2/RuleSearchesTableData';
import { FiltersData as BookingCreateManagerV2FormData } from './state/BookingCreateManagerV2/FiltersData';
import { TableData as BookingCreateManagerV2TableData } from './state/BookingCreateManagerV2/TableData';
import { EditorData as BookingCreateManagerV2EditorData } from './state/BookingCreateManagerV2/EditorData';
import { RemarksFiltersData as BookingCreateManagerV2RemarksFiltersData } from './state/BookingCreateManagerV2/Remarks/FiltersData';
import { RemarksTableData as BookingCreateManagerV2RemarksTableData } from './state/BookingCreateManagerV2/Remarks/TableData';
import { FiltersData as VccCredentialsFiltersData } from './state/VccCredentials/FiltersData';
import { TableData as VccCredentialsTableData } from './state/VccCredentials/TableData';
import { EditorData as VccCredentialsEditorData } from './state/VccCredentials/EditorData';
import { FiltersData as BCMSSRFiltersData } from './state/BookingCreateManager/SSR/FiltersData';
import { TableData as BCMSSRTableData } from './state/BookingCreateManager/SSR/TableData';
import { EditorData as BCMSSREditorData } from './state/BookingCreateManager/SSR/EditorData';
import { FiltersData as BookingTolerancesFiltersData } from './state/BookingTolerances/FiltersData';
import { TableData as BookingTolerancesTableData } from './state/BookingTolerances/TableData';
import { SearchSubRuleEditorData } from './state/SearchManagerV2/SubRuleEditorData';
import { EditorData as BookingTolerancesEditorData } from './state/BookingTolerances/EditorData';
import { AncillariesManagerFiltersData } from './state/AncillariesManager/FiltersData';
import { TableData as AncillariesManagerTableData } from './state/AncillariesManager/TableData';
import { AncillariesManagerEditorData } from './state/AncillariesManager/EditorData';
import { SearchSubRuleBulkEditorData } from './state/SearchManagerV2/SubRuleBulkEditorData';
import { EditorData as BookingCreateManagerV2RemarksEditorData } from './state/BookingCreateManagerV2/Remarks/EditorData';
import { SSRFiltersData as BookingCreateManagerV2SSRFiltersData } from './state/BookingCreateManagerV2/SSR/FiltersData';
import { SSRTableData as BookingCreateManagerV2SSRTableData } from './state/BookingCreateManagerV2/SSR/TableData';
import { EditorData as BookingCreateManagerV2SSREditorData } from './state/BookingCreateManagerV2/SSR/EditorData';
import { EditorData as MarkupsV2EditorData } from './state/MarkupsV2/EditorData';
import { FiltersData as MarkupsV2FiltersData } from './state/MarkupsV2/FiltersData';
import { TableData as MarkupsV2TableData } from './state/MarkupsV2/TableData';
import { BusinessData } from './state/BusinessData/BusinessData';
import { DistributionChannelV2EditorData } from './state/DistributionChannelsV2/EditorData';

export interface ApplicationState {
  authData: AuthStateData;
  searchManager: {
    formData: FormData;
    resultsData: ResultsData;
    ruleData: RuleData;
    ruleSearchesFormData: RuleSearchesFormData;
    ruleSearchesResultsData: RuleSearchesResultsData;
    ruleItemEditFormData: RuleItemEditFormData;
    diagnosticsExceptionFormData: FormData;
    diagnosticsExceptionResultsData: ResultsData;
  };
  searchManagerV2: {
    filtersData: SearchManagerV2FormData;
    tableData: SearchManagerV2TableData;
    editorData: SearchManagerV2EditorData;
    ruleSearchesData: SearchManagerV2RuleSearchesData;
    ruleSearchesTableData: SearchManagerV2RuleSearchesTableData;
    subRuleEditorData: SearchSubRuleEditorData;
    subRuleBulkEditorData: SearchSubRuleBulkEditorData;
  };
  bookingCreateManager: {
    osisFormData: BookingCreateManagerFormData;
    osisResultsData: BookingCreateManagerResultsData;
    osisRuleData: BookingCreateManagerRuleData;
    remarksFormData: BookingCreateManagerRemarksFormData;
    remarksResultsData: BookingCreateManagerRemarksResultsData;
    remarksRuleData: BookingCreateManagerRemarksRuleData;
  };
  bookingCreateManagerV2: {
    filtersData: BookingCreateManagerV2FormData;
    tableData: BookingCreateManagerV2TableData;
    editorData: BookingCreateManagerV2EditorData;
    remarksFiltersData: BookingCreateManagerV2RemarksFiltersData;
    remarksTableData: BookingCreateManagerV2RemarksTableData;
    remarksEditorData: BookingCreateManagerV2RemarksEditorData;
    ssrFiltersData: BookingCreateManagerV2SSRFiltersData;
    ssrTableData: BookingCreateManagerV2SSRTableData;
    ssrEditorData: BookingCreateManagerV2SSREditorData;
  };
  bookingCreateManagerSSR: {
    filtersData: BCMSSRFiltersData;
    tableData: BCMSSRTableData;
    editorData: BCMSSREditorData;
  };
  businessData: {
    regions: {
      formData: RegionsFormData;
      resultsData: RegionsResultsData;
      editorData: RegionEditorData;
    };
    countries: {
      formData: CountriesFormData;
      resultsData: CountriesResultsData;
      editorData: CountryEditorData;
    };
    locations: {
      formData: LocationsFormData;
      resultsData: LocationsResultsData;
      editorData: LocationEditorData;
    };
    stations: {
      formData: StationsFormData;
      resultsData: StationsResultsData;
      editorData: StationEditorData;
    };
    airlines: {
      formData: AirlinesFormData;
      resultsData: AirlinesResultsData;
      editorData: AirlineEditorData;
    };
    brands: {
      formData: BrandsFormData;
      resultsData: BrandsResultsData;
      editorData: BrandEditorData;
    };
    markets: {
      formData: MarketsFormData;
      resultsData: MarketsResultsData;
      editorData: MarketEditorData;
    };
    distributionChannels: {
      formData: DistributionChannelsFormData;
      resultsData: DistributionChannelsResultsData;
      editorData: DistributionChannelEditorData;
    };
    agencies: {
      formData: AgenciesFormData;
      resultsData: AgenciesResultsData;
      editorData: AgencyEditorData;
    };
    agencyGroups: {
      formData: AgencyGroupsFormData;
      resultsData: AgencyGroupsResultsData;
      editorData: AgencyGroupEditorData;
    };
    geoGroups: {
      filtersData: GeoGroupsFiltersData;
      tableData: GeoGroupsTableData;
      editorData: GeoGroupsEditorData;
    };
  };
  supplier: {
    tableData: SupplierTableData;
    editorData: SupplierEditorData;
  };
  markups: {
    formData: MarkupsFormData;
    resultsData: MarkupsResultsData;
    editorData: MarkupEditorData;
  };
  markupsV2: {
    editorData: MarkupsV2EditorData;
    filtersData: MarkupsV2FiltersData;
    tableData: MarkupsV2TableData;
  };
  providerPreferences: {
    formData: ProviderPreferencesFormData;
    resultsData: ProviderPreferencesResultsData;
    editorData: ProviderPreferenceEditorData;
  };
  providerCredentials: {
    formData: ProviderCredentialFormData;
    resultsData: ProviderCredentialsResultsData;
    editorData: ProviderCredentialsEditorData;
  };
  identityProviderSettings: {
    formData: IdentityProviderSettingsFormData;
    resultsData: IdentityProviderSettingsResultsData;
    editorData: IdentityProviderSettingsEditorData;
  };
  identitySettings: {
    formData: IdentitySettingsFormData;
    resultsData: IdentitySettingsResultsData;
    editorData: IdentitySettingsEditorData;
  };
  ticketTLO: {
    formData: TicketTLOFormData;
    resultsData: TicketTLOResultsData;
    editorData: TicketTLOEditorData;
  };
  ticketTLOV2: {
    filtersData: TicketTLOV2FormData;
    tableData: TicketTLOVV2TableData;
    editorData: TicketTLOVV2EditorData;
  };
  globalFiltersV2: {
    filtersData: GlobalFiltersV2FiltersData;
    tableData: GlobalFiltersV2TableData;
    editorData: GlobalFiltersV2EditorData;
  };
  providerCredentialsV2: {
    filtersData: ProviderCredentialsV2FiltersData;
    tableData: ProviderCredentialsV2TableData;
    editorData: ProviderCredentialsV2EditorData;
  };
  shoppingDiagnostics: {
    live: {
      shoppingDiagnosticsFormData: ShoppingDiagnosticsFormDataLive;
      shoppingDiagnosticsResultsData: ShoppingDiagnosticsResultsDataLive;
    };
    historical: {
      shoppingDiagnosticsFormData: ShoppingDiagnosticsFormDataHistorical;
      shoppingDiagnosticsResultsData: ShoppingDiagnosticsResultsDataHistorical;
    };
  };
  bookingDiagnostics: {
    bookingDiagnosticsFormData: BookingFormData;
    bookingDiagnosticsResultsData: BookingResultsData;
  };
  userPermissions: {
    FormData: UserPermissionsFormData;
    ResultsData: UserPermissionsResultsData;
    EditorData: UserPermissionsEditorData;
  };
  globalFilters: {
    FormData: GlobalFiltersFormData;
    ResultsData: GlobalFiltersResultsData;
    EditorData: GlobalFiltersEditorData;
  };
  activityLog: {
    formData: ActivityLogFormData;
    resultsData: ActivityLogResultsData;
  };
  ancillariesMapping: {
    filtersData: AncillariesMappingFiltersData;
    editorData: AncillariesMappingEditorData;
    tableData: AncillariesMappingTableData;
  };
  ancillaryDistribution: {
    filtersData: AncillaryDistributionFiltersData;
    editorData: AncillaryDistributionEditorData;
    tableData: AncillaryDistributionTableData;
  };
  ancillariesManager: {
    filtersData: AncillariesManagerFiltersData;
    tableData: AncillariesManagerTableData;
    editorData: AncillariesManagerEditorData;
  };
  vccCredentials: {
    filtersData: VccCredentialsFiltersData;
    tableData: VccCredentialsTableData;
    editorData: VccCredentialsEditorData;
  };
  bookingTolerances: {
    filtersData: BookingTolerancesFiltersData;
    tableData: BookingTolerancesTableData;
    editorData: BookingTolerancesEditorData;
  };
  businessDataV2: {
    data: BusinessData;
  };
  distributionChannelsV2: {
    data: DistributionChannelV2EditorData;
  };
}

export const applicationStore: Store<ApplicationState, Action<ActionType, any>> = createStore(combinedAppReducers, composeWithDevTools());

export default applicationStore;
